import { Head, Link, usePage } from '@inertiajs/react';
import { dashboard, login } from '@/routes';

/* @chisel-registration */
import { register } from '@/routes';
/* @end-chisel-registration */

import WebNavbar from '@/layouts/app/WebNavbar';

import { Carousel, CarouselSlide } from '@/components/home/Carousel';
import { HeroHeader } from '@/components/design/HeroHeader';
import ServiciosGrid from '@/components/home/ServiciosGrid';
import { ContactSection } from '@/components/home/ContactSection';

export default function Welcome() {
    const { auth } = usePage().props;

    // Datos de ejemplo (puedes recibirlos desde el Controller de Laravel)
    const misDiapositivas: CarouselSlide[] = [
        {
        id: 1,
        image: '/pictures/resources/CAMARAS_REDES_1.png',
        title: '',
        description: '',
        },
        {
        id: 2,
        image: '/pictures/resources/CAMARAS_REDES_2.png',
        title: '',
        description: '',
        },
        {
        id: 3,
        image: '/pictures/resources/SERVICIO_TECNICO_1.png',
        title: '',
        description: '.',
        },
    ];

    return (
        <>
            <Head title="Home" />
            <WebNavbar />
            <Carousel slides={misDiapositivas} />
  
            <HeroHeader 
                badgeText="SERVICIO TÉCNICO ESPECIALIZADO"
                titleMain=""
                titleQuestion="¿Con qué equipo"
                highlightText="necesitas ayuda"
                subtext="REPARACIÓN DE LAPTOPS, MACBOOKS, DESKTOPS, IMPRESORAS, CELULARES Y MÁS"
            />

            <ServiciosGrid />

            <ContactSection />
            
        </>
    );
}
